// extracted by mini-css-extract-plugin
module.exports = {"tombstone-table":"components-Tombstone-TabContent-TabContent__tombstone-table--26SA2"};